<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Alternatives to Valium</h1>
<p class="sub"><em>How Punk Rock Saved a Shy Boy’s Life</em></p>
<p class="aut">Alastair McKay</p>
<p class="para"> </p>
<p class="para"> </p>
<p class="pub"><img alt="Illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3bcfbbb2